import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { BannerContainer, BannerSectionContainer, BannerTextContainer, ButtonLabel } from "@similarweb/ui-components";

export const BannerWrapper = styled.div`
    width: 100%;
    ${BannerContainer} {
        height: 44px;
        box-sizing: border-box;
        background-color: ${colorsPalettes.sky[100]};
        padding: 4px 0 4px 16px;
        ${BannerSectionContainer} {
            ${BannerTextContainer} {
                margin-left: 0px;
            }
            &:last-child {
                ${ButtonLabel} {
                    font-weight: 700;
                    color: ${colorsPalettes.indigo[300]};
                }
                .SWReactIcons svg path {
                    fill: ${colorsPalettes.indigo[300]};
                }
            }
            &:last-child:hover {
                ${ButtonLabel} {
                    color: ${colorsPalettes.indigo[400]};
                }
                .SWReactIcons svg path {
                    fill: ${colorsPalettes.indigo[400]};
                }
            }
            p {
                ${setFontVariant("input2", colorsPalettes.carbon[400])};
            }
        }
    }
`;
